'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _html5_video = require('clappr/src/playbacks/html5_video/html5_video');

var _html5_video2 = _interopRequireDefault(_html5_video);

var _events = require('overrides/clappr/base/events');

var _events2 = _interopRequireDefault(_events);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HTML5Video = function (_BaseHTML5Video) {
    _inherits(HTML5Video, _BaseHTML5Video);

    function HTML5Video() {
        _classCallCheck(this, HTML5Video);

        return _possibleConstructorReturn(this, (HTML5Video.__proto__ || Object.getPrototypeOf(HTML5Video)).apply(this, arguments));
    }

    _createClass(HTML5Video, [{
        key: 'setPlaybackRate',

        /**
         * Set playback rate
         * @param {Float} Playback rate, 1.0 is default 2.0 is 2x faster ...
         * @return {void}
         */
        value: function setPlaybackRate(rate) {
            this.el.playbackRate = rate;
            this.trigger(_events2.default.PLAYBACK_RATEUPDATE, rate);
        }
    }]);

    return HTML5Video;
}(_html5_video2.default);

exports.default = HTML5Video;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/player/overrides/clappr/playbacks/html5_video/html5_video.js
// module id = 110
// module chunks = 0